import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import { ForbiddenPage } from '@/components/common/ForbiddenPage';
import { LoadingOverlay } from '@/components/common/LoadingOverlay';
import { NotFoundPage } from '@/components/common/NotFoundPage';
import { AppLayout } from '@/components/layout/AppLayout';
import { PERMISSIONS } from '@/constants/permissions';
import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';
import { RequirePermission } from '@/features/auth/components/RequirePermission';

const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage').then((m) => ({ default: m.LoginPage })));
const DashboardPage = lazy(() =>
  import('@/features/dashboard/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);
const UsersPage = lazy(() => import('@/features/users/pages/UsersPage').then((m) => ({ default: m.UsersPage })));
const CategoriesPage = lazy(() =>
  import('@/features/categories/pages/CategoriesPage').then((m) => ({ default: m.CategoriesPage })),
);
const QuizzesPage = lazy(() =>
  import('@/features/quizzes/pages/QuizzesPage').then((m) => ({ default: m.QuizzesPage })),
);
const NotificationsPage = lazy(() =>
  import('@/features/notifications/pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);

export function AppRouter() {
  return (
    <Suspense fallback={<LoadingOverlay />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/403" element={<ForbiddenPage />} />

        <Route path="/" element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />

            <Route element={<RequirePermission permissions={[PERMISSIONS.DASHBOARD_VIEW]} />}>
              <Route path="dashboard" element={<DashboardPage />} />
            </Route>

            <Route element={<RequirePermission permissions={[PERMISSIONS.USERS_VIEW]} />}>
              <Route path="users" element={<UsersPage />} />
            </Route>

            <Route element={<RequirePermission permissions={[PERMISSIONS.CATEGORIES_VIEW]} />}>
              <Route path="categories" element={<CategoriesPage />} />
            </Route>

            <Route element={<RequirePermission permissions={[PERMISSIONS.QUIZZES_VIEW]} />}>
              <Route path="quizzes" element={<QuizzesPage />} />
            </Route>

            <Route element={<RequirePermission permissions={[PERMISSIONS.NOTIFICATIONS_VIEW]} />}>
              <Route path="notifications" element={<NotificationsPage />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
